export default "__VITE_ASSET__Bj591kjg__"